import {
  FETCH_APPOINTMENTS_BETWEEN_DATES_SUCCESS,
  SHOW_APPOINTMENTS_LOADER,
  SHOW_APPOINTMENTS_MESSAGE,
  SAVE_APPOINTMENTS_SUCCESS,
  HIDE_APPOINTMENTS_MESSAGE,
  FETCH_APPOINTMENTS_DOCTORS_SUCCESS,
  DELETE_APPOINTMENTS_SUCCESS
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: true,
  apiLoaded: 2,
  alertMessage: '',
  showMessage: false,
  isErrorMessage: false,
  appointments: [],
  doctors: []
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_APPOINTMENTS_BETWEEN_DATES_SUCCESS: {
      return {
        ...state,
        appointments: action.payload,
        loader: false,
      }
    }
    case SHOW_APPOINTMENTS_LOADER: {
      return {
        ...state,
        loader: true,
      }
    }
    case SHOW_APPOINTMENTS_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload.message,
        isErrorMessage: action.payload.messageStatus,
        showMessage: true,
        loader: false
      }
    }
    case SAVE_APPOINTMENTS_SUCCESS: {
      let isNew = true;
      const appointments = state.appointments.map((appointment) => {
        if (appointment.id === action.payload.id) {
          isNew = false;
          return action.payload
        } else {
          return appointment
        }
      });
      if (isNew) {
        appointments.push(action.payload);
      }

      return {
        ...state,
        alertMessage: isNew ? 'appointments.successufullyAdded' : 'appointments.successufullyUpdated',
        showMessage: true,
        isErrorMessage: false,
        appointments: appointments,
        loader: false
      }
    }
    case HIDE_APPOINTMENTS_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        isErrorMessage: false,
        showMessage: false,
        loader: false
      }
    }
    case FETCH_APPOINTMENTS_DOCTORS_SUCCESS: {
      return {
        ...state,
        doctors: action.payload,
      }
    }
    case DELETE_APPOINTMENTS_SUCCESS: {
      const appointments = state.appointments.filter(function (appointment) {
        return appointment.id !== action.payload.id;
      });

      return {
        ...state,
        alertMessage: 'appointments.successufullyDeleted',
        showMessage: true,
        appointments: appointments,
        loader: false
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/Appointment.js